import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const INITIAL_STATE = {
  data: [],
  selectedRecordIndex: 0,
  isOverlayOpen: false
};

const FeedbackOverlayModel = types
  .model('FeedbackOverlayModel', {
    data: types.frozen(),
    selectedRecordIndex: types.optional(types.number, 0),
    isOverlayOpen: types.optional(types.boolean, false)
  })
  .actions((self) => {
    const eventManager = Framework.getEventManager();

    return {
      fetch(payload) {
        eventManager.publish(constants.GET_USER_AUDIT_FEEDBACK_DATA, { payload });
      },
      setResponse(response) {
        applySnapshot(self, {
          ...response,
          selectedRecordIndex: self.selectedRecordIndex,
          isOverlayOpen: self.isOverlayOpen
        });
        eventManager.publish(constants.GET_FEEDBACK_OVERLAY_DATA_RESPONSE);
      },
      setSelectedRecordIndex(index) {
        return applySnapshot(self, { ...self, selectedRecordIndex: index });
      },
      setIsOverlayOpen(value) {
        return applySnapshot(self, { ...self, isOverlayOpen: value });
      },
      resetStateValues() {
        applySnapshot(self, INITIAL_STATE);
        eventManager.publish(constants.GET_FEEDBACK_OVERLAY_DATA_RESPONSE);
      }
    };
  })
  .views((self) => ({
    get currentSelectedRecordIndex() {
      return self.selectedRecordIndex;
    },
    get currentOverlayOpenedState() {
      return self.isOverlayOpen;
    }
  }));

export default FeedbackOverlayModel;
